<template>
  <div ref="mapContainer" class="map-container"></div>
</template>

<script>
import mapboxgl from 'mapbox-gl';

export default {
  name: 'RecordingCropAppMap',
  props: {
    // Expect a GeoJSON string containing your route data
    lineString: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      map: null,
      styleLoaded: false,
    };
  },
  mounted() {
    mapboxgl.accessToken = 'pk.eyJ1IjoiaGlpa2VyLW1hcHMiLCJhIjoiY2x0YThyZHppMWhmejJqbzExODBuY3dveiJ9.nBrtnXgbzxpAx_953HCB-w';
    window.recording_crop_app_map = new mapboxgl.Map({
      container: this.$refs.mapContainer,
      style: 'https://hiiker.app/mapbox_style_jsons/standard.json',
      center: window.lonlat || [0, 0],
      zoom: 12,
    });

    window.recording_crop_app_map.on('style.load', () => {
      this.styleLoaded = true;
      if (this.lineString && this.lineString.trim() !== '') {
        this.addRouteLayer(this.lineString);
      }
    });
  },
  watch: {
    lineString(newVal) {
      if (newVal && newVal.trim() !== '' && this.styleLoaded) {
        this.addRouteLayer(newVal);
      }
    },
  },
  methods: {
    addRouteLayer(lineStringData) {
      if (!lineStringData || lineStringData.trim() === '') {
        console.warn('No valid GeoJSON provided.');
        return;
      }
      try {
        const geoJson = JSON.parse(lineStringData);
        if (window.recording_crop_app_map.getSource('route')) {
          window.recording_crop_app_map.getSource('route').setData(geoJson);
          return;
        }
        window.recording_crop_app_map.addSource('route', {
          type: 'geojson',
          data: geoJson,
        });
        window.recording_crop_app_map.addLayer({
          id: 'route-layer',
          type: 'line',
          source: 'route',
          layout: {
            'line-join': 'round',
            'line-cap': 'round',
          },
          paint: {
            'line-color': '#ff7e5f',
            'line-width': 4,
          },
        });
      } catch (error) {
        console.error('Error parsing GeoJSON:', error);
      }
    },
  },
  beforeDestroy() {
    if (window.recording_crop_app_map) {
      window.recording_crop_app_map.remove();
    }
  },
};
</script>

<style scoped>
.map-container {
  width: 100%;
  height: 85vh;
}
</style>
